export default __webpack_public_path__ + "static/media/14.3a2bb127.png";